export enum AppLoaders {
  AppInitLoader = 'Initial App Loader',
  SerpLiteLoader = 'Serp Lite Loader',
  RatesSerpLoader = 'Rates Serp Loader',
  ClaimsSerpLoader = 'Claims Serp Loader',
}
